import { IGuidOptions } from "../../../../../../apps/idl/src/model";
import { IGuidBuilder } from "./iguid-builder";

export class LongGuidBuilder implements IGuidBuilder {
	/** @implements */
	public build(poOptions: IGuidOptions = {}): string {
		let lsGuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (psLetter: string) => {
			const lnRandomNumber = Math.random() * 16 | 0;
			return (psLetter === 'x' ? lnRandomNumber : (lnRandomNumber & (0x3 | 0x8))).toString(16);
		});

		if (!poOptions.withHyphens)
			lsGuid = lsGuid.replace(/-/g, '');

		if (poOptions.upperCase)
			lsGuid = lsGuid.toUpperCase();

		return lsGuid;
	}

	/** @implements */
	public isValid(psGuid: string): boolean {
		return (/^[0-9a-fA-F]{8}-?[0-9a-fA-F]{4}-?[1-5][0-9a-fA-F]{3}-?[0-9a-fA-F]{4}-?[0-9a-fA-F]{12}$/i).test(psGuid);
	}
}
